import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaLaptopCode, FaRocket } from 'react-icons/fa';
import styles from './Experience.module.css';

const Experience = () => {
  // 🔥 Yahan apni Real Journey update karo
  const timeline = [
    {
      role: "Software Engineering Job Simulation",
      company: "Goldman Sachs", // Replace with real company
      date: "Sept 2024",
      desc: "Optimized backend queries. Crack leaked password Database",
      skills: ["Query Optimization", "Python", "Database Tuning"],
      icon: <FaBriefcase />
    },
    {
      role: "Software Developer Intern",
      company: "Ideovent Technologies",
      date: "Jun 2025 - Sept 2025",
      desc: "Led a 6-member Agile team to architect and deploy scalable APIs. Boosted platform security & performance by optimizing MongoDB queries and implementing JWT authentication..",
      skills: ["MERN", "Leadership", "Team Lead"],
      icon: <FaLaptopCode />
    },
    {
      role: "Participants in hackathon",
      company: "Oddo x GCET Hackathon",
      date: "2026",
      desc: "Participated in hackathon and build a Rental Management System.",
      skills: ["MERN", "Version Control", "Deployment"],
      icon: <FaRocket />
    }
  ];

  return (
    <section id="experience" className={styles.expSection}>
      <div className={styles.container}>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className={styles.header}
        >
          <h2 className="text-gradient">Tech Journey</h2>
          <p className={styles.subtitle}>My path from Hello World to System Architect.</p>
        </motion.div>

        <div className={styles.timeline}>
          {/* Central Line */}
          <div className={styles.line}></div>

          {timeline.map((item, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className={`${styles.timelineItem} ${index % 2 === 0 ? styles.left : styles.right}`}
            >
              {/* Dot on the line */}
              <div className={styles.dot}>
                {item.icon}
              </div>

              {/* Content Card */}
              <div className={`${styles.content} glass`}>
                <span className={styles.date}>{item.date}</span>
                <h3 className={styles.role}>{item.role}</h3>
                <h4 className={styles.company}>{item.company}</h4>
                <p className={styles.desc}>{item.desc}</p>
                
                <div className={styles.skills}>
                  {item.skills.map((skill, i) => (
                    <span key={i} className={styles.tag}>{skill}</span>
                  ))}
                </div>
                
                {/* Arrow pointing to dot */}
                <div className={styles.arrow}></div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Experience;